'use client';

import { c as _c } from "react/compiler-runtime";
import { getOutcomeCount } from '@svs/nova-poolbetting/core/lib/client';
import { useCouponId, useCouponOutcomes } from '@svs/nova-poolbetting/core/nextjs/coupon';
import { useEngine } from '@svs/nova-poolbetting/core/nextjs/engine';
import type { CouponIndex } from '@svs/nova-poolbetting/schema/coupon';
import type { EventNumber, EventType, Participant, SportType } from '@svs/nova-poolbetting/schema/sport';
import type { ReactNode } from 'react';
import CouponOverviewRow from './CouponOverviewRow';
type CouponOverviewRowContainerProps = {
  couponIndex: CouponIndex;
  eventParticipants?: (Participant | undefined)[];
  eventNumber: EventNumber;
  eventDescription: string;
  sportType: SportType;
  eventType: EventType;
};

/**
 * CouponOverview component.
 *
 * @param root0 - The props object.
 * @param root0.couponIndex - The index of the current coupon
 * @param root0.eventParticipants - The participants of the current draw
 * @param root0.eventNumber - The number of the current event
 * @param root0.eventDescription - The description of the current event
 * @param root0.eventType - The type of the current event
 * @param root0.sportType - The sport type of the current event
 * @returns A coupon row of the coupon overview component.
 */
export default function CouponOverviewRowContainer(t0) {
  const $ = _c(14);
  const {
    couponIndex,
    eventParticipants,
    eventNumber,
    eventDescription,
    eventType,
    sportType
  } = t0;
  const definition = useEngine();
  const [couponId] = useCouponId();
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex || $[2] !== eventNumber) {
    t1 = {
      couponId,
      eventNumber,
      boardIndex: 0,
      couponIndex,
      groupIndex: 0
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = eventNumber;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedOutcomes = useCouponOutcomes(t1);
  let t2;
  if ($[4] !== definition.model || $[5] !== eventType || $[6] !== sportType) {
    t2 = getOutcomeCount(sportType, eventType, definition.model);
    $[4] = definition.model;
    $[5] = eventType;
    $[6] = sportType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const outcomeCount = t2;
  let t3;
  if ($[8] !== eventDescription || $[9] !== eventNumber || $[10] !== eventParticipants || $[11] !== outcomeCount || $[12] !== selectedOutcomes) {
    t3 = <CouponOverviewRow eventParticipants={eventParticipants} eventNumber={eventNumber} eventDescription={eventDescription} selectedOutcomes={selectedOutcomes} outcomeCount={outcomeCount} />;
    $[8] = eventDescription;
    $[9] = eventNumber;
    $[10] = eventParticipants;
    $[11] = outcomeCount;
    $[12] = selectedOutcomes;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}